export default {
	name: "Pagination",
	props: {
		currentPage: {
			type: Number,
			required: true,
		},
		lastPage: {
			type: Number,
			required: true,
		},
		handler: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			localCurrentPage: 1,
			hasNextButton: false,
			hasFirstSection: false,
			hasBackButton: false,
			hasLastSection: false,
		};
	},
	computed: {
		isBetweenTheFirstPages() {
			return this.localCurrentPageAsNumber <= 5;
		},
		isBetweenTheLastPages() {
			return this.localCurrentPageAsNumber > this.lastPage - 5;
		},
		pageNumbersList() {
			if (this.isBetweenTheFirstPages) {
				return this.numbersInRange(
					1,
					this.lastPage <= 6 ? this.lastPage : 6
				);
			}

			if (this.isBetweenTheLastPages) {
				return this.numbersInRange(this.lastPage - 5, this.lastPage);
			}

			return [
				...this.numbersInRange(
					this.localCurrentPageAsNumber - 2,
					this.localCurrentPageAsNumber
				),
				...this.numbersInRange(
					this.localCurrentPageAsNumber + 1,
					this.localCurrentPageAsNumber + 2
				),
			];
		},
		localCurrentPageAsNumber() {
			return parseInt(this.localCurrentPage, 10);
		},
		isNumber() {
			return !Number.isNaN(this.localCurrentPageAsNumber);
		},
	},
	methods: {
		numbersInRange(lowBound, highBound) {
			let numbersList = [];
			for (let i = lowBound; i <= highBound; i++) {
				numbersList.push(i);
			}
			return numbersList;
		},
		onPageBtnClick(newPage) {
			return this.handler(newPage);
		},
		onNextBtnClick() {
			return this.handler(this.localCurrentPageAsNumber + 1);
		},
		onBackBtnClick() {
			return this.handler(this.localCurrentPageAsNumber - 1);
		},
		isActivePage(buttonValue) {
			return this.localCurrentPageAsNumber === buttonValue;
		},
		handleSubmit() {
			return this.handler(this.localCurrentPageAsNumber);
		},
	},
	mounted() {
		this.localCurrentPage = this.currentPage;
	},
	watch: {
		currentPage(newValue) {
			this.localCurrentPage = newValue;
		},
	},
};
